// Device preferences in localStorage. Keys are kept from the single-file
// viewer so existing users keep their settings.
export const PREF = {
  width: 'portal_width',
  bgHex: 'portal_bg_hex',
  solidHex: 'portal_solid_hex',
  detail: 'portal_detail',
  shotScale: 'portal_shot_scale',
  theme: 'portal_theme',        // 'auto' | 'light' | 'dark'
} as const;

export function safeGet(key: string, fallback: string): string {
  try {
    const v = localStorage.getItem(key);
    return v === null || v === '' ? fallback : v;
  } catch {
    return fallback;
  }
}

export function safeSet(key: string, value: string): void {
  try { localStorage.setItem(key, value); } catch { /* ignore */ }
}
